import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { ISubscriberInfo } from '../../interfaces';

export function useSubscriberInfo(): ISubscriberInfo {
    return useContext(MobXProviderContext).RootStore.subscriberStore.info;
}
